import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Collapse from '@mui/material/Collapse'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

const MenuItem = ({
  path,
  name,
  Icon,
  active,
  submenu,
  onClick
}: {
  path: string,
  name: string,
  Icon: any,
  active: boolean,
  submenu: {path: string, name: string, svg: any}[],
  onClick: any
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(active)
  const location = useLocation()
  const hasSubmenu = submenu.length > 0

  const toggleExpand = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(prev => !prev)
  }

  return (
    <div className='menu-item-holder'>
      <Link
        role='link'
        className={`menu-item ${active && !hasSubmenu ? 'active' : ''} ${open && hasSubmenu ? 'open' : ''}`}
        to={path}
        onClick={(e) => {
          if (path === '#') {
            e.preventDefault()
            if (hasSubmenu) {
              setOpen(prev => !prev)
            }
          }
          if (onClick) {
            onClick()
          }
        }}
      >
        <Icon />
        {name}
        {hasSubmenu && (
          <button
            onClick={toggleExpand}
            className='toggle-submenu'
            aria-label={open ? String(t('SIDEBAR.COLLAPSE_SUBMENU')) : String(t('SIDEBAR.EXPAND_SUBMENU'))}
            type='button'
          >
            {open ? (
              <ChevronUpIcon aria-hidden='true' focusable='false' />
            ) : (
              <ChevronDownIcon aria-hidden='true' focusable='false' />
            )}
          </button>
        )}
      </Link>
      {hasSubmenu && (
        <Collapse in={open} timeout='auto' unmountOnExit>
          <div className='submenu-wrapper'>
            {submenu.map((item) => {
              const label = `NAVBAR.${item.name}`
              const isItemActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/')
              return (
                <li
                  className={`submenu-item-holder ${isItemActive ? 'active' : ''}`}
                  key={item.name}
                  role='listitem'
                >
                  <Link className='submenu-item' to={item.path} role='link'>
                {item.svg && <item.svg />}
                {t(label)}
              </Link>
                </li>
              )
            })}
          </div>
        </Collapse>
      )}
    </div>
  )
}

export default MenuItem
